import { render, staticRenderFns } from "./LinkIcon.vue?vue&type=template&id=4c2d5942&functional=true"
import script from "./LinkIcon.vue?vue&type=script&lang=js"
export * from "./LinkIcon.vue?vue&type=script&lang=js"
import style0 from "./LinkIcon.vue?vue&type=style&index=0&id=4c2d5942&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports